export const getGroupsPath = (companyId: string) => {
  return `/companies/${companyId}/user_groups`;
};

export const groupsResourceType = "user_group" as const;
